const phonecodes = [
  { id: 1, iso: "IN", name: "India", phonecode: "+91" },
  { id: 2, iso: "AL", name: "Albania", phonecode: "+355" },
  { id: 3, iso: "DZ", name: "Algeria", phonecode: "+213" },
  { id: 4, iso: "AS", name: "American Samoa", phonecode: "+1684" },
  { id: 5, iso: "AD", name: "Andorra", phonecode: "+376" },
  { id: 6, iso: "AO", name: "Angola", phonecode: "+244" },
  { id: 7, iso: "AI", name: "Anguilla", phonecode: "+1264" },
  { id: 8, iso: "AQ", name: "Antarctica", phonecode: "+0" },
  { id: 9, iso: "AG", name: "Antigua and Barbuda", phonecode: "+1268" },
  { id: 10, iso: "AR", name: "Argentina", phonecode: "+54" },
  { id: 11, iso: "AM", name: "Armenia", phonecode: "+374" },
  { id: 12, iso: "AW", name: "Aruba", phonecode: "+297" },
  { id: 13, iso: "AU", name: "Australia", phonecode: "+61" },
  { id: 14, iso: "AT", name: "Austria", phonecode: "+43" },
  { id: 15, iso: "AZ", name: "Azerbaijan", phonecode: "+994" },
  { id: 16, iso: "BS", name: "Bahamas", phonecode: "+1242" },
  { id: 17, iso: "BH", name: "Bahrain", phonecode: "+973" },
  { id: 18, iso: "BD", name: "Bangladesh", phonecode: "+880" },
  { id: 19, iso: "BB", name: "Barbados", phonecode: "+1246" },
  { id: 20, iso: "BY", name: "Belarus", phonecode: "+375" },
  { id: 21, iso: "BE", name: "Belgium", phonecode: "+32" },
  { id: 22, iso: "BZ", name: "Belize", phonecode: "+501" },
  { id: 23, iso: "BJ", name: "Benin", phonecode: "+229" },
  { id: 24, iso: "BM", name: "Bermuda", phonecode: "+1441" },
  { id: 25, iso: "BT", name: "Bhutan", phonecode: "+975" },
  { id: 26, iso: "BO", name: "Bolivia", phonecode: "+591" },
  { id: 27, iso: "BA", name: "Bosnia and Herzegovina", phonecode: "+387" },
  { id: 28, iso: "BW", name: "Botswana", phonecode: "+267" },
  { id: 29, iso: "BV", name: "Bouvet Island", phonecode: "+0" },
  { id: 30, iso: "BR", name: "Brazil", phonecode: "+55" },
  {
    id: 31,
    iso: "IO",
    name: "British Indian Ocean Territory",
    phonecode: "+246",
  },
  { id: 32, iso: "BN", name: "Brunei", phonecode: "+673" },
  { id: 33, iso: "BG", name: "Bulgaria", phonecode: "+359" },
  { id: 34, iso: "BF", name: "Burkina Faso", phonecode: "+226" },
  { id: 35, iso: "BI", name: "Burundi", phonecode: "+257" },
  { id: 36, iso: "KH", name: "Cambodia", phonecode: "+855" },
  { id: 37, iso: "CM", name: "Cameroon", phonecode: "+237" },
  { id: 38, iso: "CA", name: "Canada", phonecode: "+1" },
  { id: 39, iso: "CV", name: "Cape Verde", phonecode: "+238" },
  { id: 40, iso: "KY", name: "Cayman Islands", phonecode: "+1345" },
  { id: 41, iso: "CF", name: "Central African Republic", phonecode: "+236" },
  { id: 42, iso: "TD", name: "Chad", phonecode: "+235" },
  { id: 43, iso: "CL", name: "Chile", phonecode: "+56" },
  { id: 44, iso: "CN", name: "China", phonecode: "+86" },
  { id: 45, iso: "CX", name: "Christmas Island", phonecode: "+61" },
  { id: 46, iso: "CC", name: "Cocos (Keeling) Islands", phonecode: "+672" },
  { id: 47, iso: "CO", name: "Colombia", phonecode: "+57" },
  { id: 48, iso: "KM", name: "Comoros", phonecode: "+269" },
  { id: 49, iso: "CG", name: "Congo", phonecode: "+242" },
  { id: 50, iso: "CD", name: "Congo (DRC)", phonecode: "+242" },
  { id: 51, iso: "CK", name: "Cook Islands", phonecode: "+682" },
  { id: 52, iso: "CR", name: "Costa Rica", phonecode: "+506" },
  { id: 53, iso: "CI", name: "Cote d'Ivoire", phonecode: "+225" },
  { id: 54, iso: "HR", name: "Croatia", phonecode: "+385" },
  { id: 55, iso: "CU", name: "Cuba", phonecode: "+53" },
  { id: 56, iso: "CY", name: "Cyprus", phonecode: "+357" },
  { id: 57, iso: "CZ", name: "Czech Republic", phonecode: "+420" },
  { id: 58, iso: "DK", name: "Denmark", phonecode: "+45" },
  { id: 59, iso: "DJ", name: "Djibouti", phonecode: "+253" },
  { id: 60, iso: "DM", name: "Dominica", phonecode: "+1767" },
  { id: 61, iso: "DO", name: "Dominican Republic", phonecode: "+1809" },
  { id: 62, iso: "EC", name: "Ecuador", phonecode: "+593" },
  { id: 63, iso: "EG", name: "Egypt", phonecode: "+20" },
  { id: 64, iso: "SV", name: "El Salvador", phonecode: "+503" },
  { id: 65, iso: "GQ", name: "Equatorial Guinea", phonecode: "+240" },
  { id: 66, iso: "ER", name: "Eritrea", phonecode: "+291" },
  { id: 67, iso: "EE", name: "Estonia", phonecode: "+372" },
  { id: 68, iso: "ET", name: "Ethiopia", phonecode: "+251" },
  { id: 69, iso: "FK", name: "Falkland Islands", phonecode: "+500" },
  { id: 70, iso: "FO", name: "Faroe Islands", phonecode: "+298" },
  { id: 71, iso: "FJ", name: "Fiji", phonecode: "+679" },
  { id: 72, iso: "FI", name: "Finland", phonecode: "+358" },
  { id: 73, iso: "FR", name: "France", phonecode: "+33" },
  { id: 74, iso: "GF", name: "French Guiana", phonecode: "+594" },
  { id: 75, iso: "PF", name: "French Polynesia", phonecode: "+689" },
  { id: 76, iso: "TF", name: "French Southern Territories", phonecode: "+0" },
  { id: 77, iso: "GA", name: "Gabon", phonecode: "+241" },
  { id: 78, iso: "GM", name: "Gambia", phonecode: "+220" },
  { id: 79, iso: "GE", name: "Georgia", phonecode: "+995" },
  { id: 80, iso: "DE", name: "Germany", phonecode: "+49" },
  { id: 81, iso: "GH", name: "Ghana", phonecode: "+233" },
  { id: 82, iso: "GI", name: "Gibraltar", phonecode: "+350" },
  { id: 83, iso: "GR", name: "Greece", phonecode: "+30" },
  { id: 84, iso: "GL", name: "Greenland", phonecode: "+299" },
  { id: 85, iso: "GD", name: "Grenada", phonecode: "+1473" },
  { id: 86, iso: "GP", name: "Guadeloupe", phonecode: "+590" },
  { id: 87, iso: "GU", name: "Guam", phonecode: "+1671" },
  { id: 88, iso: "GT", name: "Guatemala", phonecode: "+502" },
  { id: 89, iso: "GN", name: "Guinea", phonecode: "+224" },
  { id: 90, iso: "GW", name: "Guinea-Bissau", phonecode: "+245" },
  { id: 91, iso: "GY", name: "Guyana", phonecode: "+592" },
  { id: 92, iso: "HT", name: "Haiti", phonecode: "+509" },
  {
    id: 93,
    iso: "HM",
    name: "Heard Island and McDonald Islands",
    phonecode: "+0",
  },
  { id: 94, iso: "VA", name: "Vatican City", phonecode: "+39" },
  { id: 95, iso: "HN", name: "Honduras", phonecode: "+504" },
  { id: 96, iso: "HK", name: "Hong Kong", phonecode: "+852" },
  { id: 97, iso: "HU", name: "Hungary", phonecode: "+36" },
  { id: 98, iso: "IS", name: "Iceland", phonecode: "+354" },
  { id: 99, iso: "AF", name: "Afghanistan", phonecode: "+93" },
  { id: 100, iso: "ID", name: "Indonesia", phonecode: "+62" },
  { id: 101, iso: "IR", name: "Iran", phonecode: "+98" },
  { id: 102, iso: "IQ", name: "Iraq", phonecode: "+964" },
  { id: 103, iso: "IE", name: "Ireland", phonecode: "+353" },
  { id: 104, iso: "IL", name: "Israel", phonecode: "+972" },
  { id: 105, iso: "IT", name: "Italy", phonecode: "+39" },
  { id: 106, iso: "JM", name: "Jamaica", phonecode: "+1876" },
  { id: 107, iso: "JP", name: "Japan", phonecode: "+81" },
  { id: 108, iso: "JO", name: "Jordan", phonecode: "+962" },
  { id: 109, iso: "KZ", name: "Kazakhstan", phonecode: "+7" },
  { id: 110, iso: "KE", name: "Kenya", phonecode: "+254" },
  { id: 111, iso: "KI", name: "Kiribati", phonecode: "+686" },
  { id: 112, iso: "KP", name: "North Korea", phonecode: "+850" },
  { id: 113, iso: "KR", name: "South Korea", phonecode: "+82" },
  { id: 114, iso: "KW", name: "Kuwait", phonecode: "+965" },
  { id: 115, iso: "KG", name: "Kyrgyzstan", phonecode: "+996" },
  { id: 116, iso: "LA", name: "Laos", phonecode: "+856" },
  { id: 117, iso: "LV", name: "Latvia", phonecode: "+371" },
  { id: 118, iso: "LB", name: "Lebanon", phonecode: "+961" },
  { id: 119, iso: "LS", name: "Lesotho", phonecode: "+266" },
  { id: 120, iso: "LR", name: "Liberia", phonecode: "+231" },
  { id: 121, iso: "LY", name: "Libya", phonecode: "+218" },
  { id: 122, iso: "LI", name: "Liechtenstein", phonecode: "+423" },
  { id: 123, iso: "LT", name: "Lithuania", phonecode: "+370" },
  { id: 124, iso: "LU", name: "Luxembourg", phonecode: "+352" },
  { id: 125, iso: "MO", name: "Macao", phonecode: "+853" },
  { id: 126, iso: "MK", name: "North Macedonia", phonecode: "+389" },
  { id: 127, iso: "MG", name: "Madagascar", phonecode: "+261" },
  { id: 128, iso: "MW", name: "Malawi", phonecode: "+265" },
  { id: 129, iso: "MY", name: "Malaysia", phonecode: "+60" },
  { id: 130, iso: "MV", name: "Maldives", phonecode: "+960" },
  { id: 131, iso: "ML", name: "Mali", phonecode: "+223" },
  { id: 132, iso: "MT", name: "Malta", phonecode: "+356" },
  { id: 133, iso: "MH", name: "Marshall Islands", phonecode: "+692" },
  { id: 134, iso: "MQ", name: "Martinique", phonecode: "+596" },
  { id: 135, iso: "MR", name: "Mauritania", phonecode: "+222" },
  { id: 136, iso: "MU", name: "Mauritius", phonecode: "+230" },
  { id: 137, iso: "YT", name: "Mayotte", phonecode: "+269" },
  { id: 138, iso: "MX", name: "Mexico", phonecode: "+52" },
  { id: 139, iso: "FM", name: "Micronesia", phonecode: "+691" },
  { id: 140, iso: "MD", name: "Moldova", phonecode: "+373" },
  { id: 141, iso: "MC", name: "Monaco", phonecode: "+377" },
  { id: 142, iso: "MN", name: "Mongolia", phonecode: "+976" },
  { id: 143, iso: "MS", name: "Montserrat", phonecode: "+1664" },
  { id: 144, iso: "MA", name: "Morocco", phonecode: "+212" },
  { id: 145, iso: "MZ", name: "Mozambique", phonecode: "+258" },
  { id: 146, iso: "MM", name: "Myanmar", phonecode: "+95" },
  { id: 147, iso: "NA", name: "Namibia", phonecode: "+264" },
  { id: 148, iso: "NR", name: "Nauru", phonecode: "+674" },
  { id: 149, iso: "NP", name: "Nepal", phonecode: "+977" },
  { id: 150, iso: "NL", name: "Netherlands", phonecode: "+31" },
  { id: 151, iso: "AN", name: "Netherlands Antilles", phonecode: "+599" },
  { id: 152, iso: "NC", name: "New Caledonia", phonecode: "+687" },
  { id: 153, iso: "NZ", name: "New Zealand", phonecode: "+64" },
  { id: 154, iso: "NI", name: "Nicaragua", phonecode: "+505" },
  { id: 155, iso: "NE", name: "Niger", phonecode: "+227" },
  { id: 156, iso: "NG", name: "Nigeria", phonecode: "+234" },
  { id: 157, iso: "NU", name: "Niue", phonecode: "+683" },
  { id: 158, iso: "NF", name: "Norfolk Island", phonecode: "+672" },
  { id: 159, iso: "MP", name: "Northern Mariana Islands", phonecode: "+1670" },
  { id: 160, iso: "NO", name: "Norway", phonecode: "+47" },
  { id: 161, iso: "OM", name: "Oman", phonecode: "+968" },
  { id: 162, iso: "PK", name: "Pakistan", phonecode: "+92" },
  { id: 163, iso: "PW", name: "Palau", phonecode: "+680" },
  { id: 164, iso: "PS", name: "Palestine", phonecode: "+970" },
  { id: 165, iso: "PA", name: "Panama", phonecode: "+507" },
  { id: 166, iso: "PG", name: "Papua New Guinea", phonecode: "+675" },
  { id: 167, iso: "PY", name: "Paraguay", phonecode: "+595" },
  { id: 168, iso: "PE", name: "Peru", phonecode: "+51" },
  { id: 169, iso: "PH", name: "Philippines", phonecode: "+63" },
  { id: 170, iso: "PN", name: "Pitcairn", phonecode: "+0" },
  { id: 171, iso: "PL", name: "Poland", phonecode: "+48" },
  { id: 172, iso: "PT", name: "Portugal", phonecode: "+351" },
  { id: 173, iso: "PR", name: "Puerto Rico", phonecode: "+1787" },
  { id: 174, iso: "QA", name: "Qatar", phonecode: "+974" },
  { id: 175, iso: "RE", name: "Reunion", phonecode: "+262" },
  { id: 176, iso: "RO", name: "Romania", phonecode: "+40" },
  { id: 177, iso: "RU", name: "Russia", phonecode: "+7" },
  { id: 178, iso: "RW", name: "Rwanda", phonecode: "+250" },
  { id: 179, iso: "SH", name: "Saint Helena", phonecode: "+290" },
  { id: 180, iso: "KN", name: "Saint Kitts and Nevis", phonecode: "+1869" },
  { id: 181, iso: "LC", name: "Saint Lucia", phonecode: "+1758" },
  { id: 182, iso: "PM", name: "Saint Pierre and Miquelon", phonecode: "+508" },
  {
    id: 183,
    iso: "VC",
    name: "Saint Vincent and the Grenadines",
    phonecode: "+1784",
  },
  { id: 184, iso: "WS", name: "Samoa", phonecode: "+685" },
  { id: 185, iso: "SM", name: "San Marino", phonecode: "+378" },
  { id: 186, iso: "ST", name: "Sao Tome and Principe", phonecode: "+239" },
  { id: 187, iso: "SA", name: "Saudi Arabia", phonecode: "+966" },
  { id: 188, iso: "SN", name: "Senegal", phonecode: "+221" },
  { id: 189, iso: "RS", name: "Serbia", phonecode: "+381" },
  { id: 190, iso: "SC", name: "Seychelles", phonecode: "+248" },
  { id: 191, iso: "SL", name: "Sierra Leone", phonecode: "+232" },
  { id: 192, iso: "SG", name: "Singapore", phonecode: "+65" },
  { id: 193, iso: "SK", name: "Slovakia", phonecode: "+421" },
  { id: 194, iso: "SI", name: "Slovenia", phonecode: "+386" },
  { id: 195, iso: "SB", name: "Solomon Islands", phonecode: "+677" },
  { id: 196, iso: "SO", name: "Somalia", phonecode: "+252" },
  { id: 197, iso: "ZA", name: "South Africa", phonecode: "+27" },
  {
    id: 198,
    iso: "GS",
    name: "South Georgia and the South Sandwich Islands",
    phonecode: "+0",
  },
  { id: 199, iso: "ES", name: "Spain", phonecode: "+34" },
  { id: 200, iso: "LK", name: "Sri Lanka", phonecode: "+94" },
  { id: 201, iso: "SD", name: "Sudan", phonecode: "+249" },
  { id: 202, iso: "SR", name: "Suriname", phonecode: "+597" },
  { id: 203, iso: "SJ", name: "Svalbard and Jan Mayen", phonecode: "+47" },
  { id: 204, iso: "SZ", name: "Eswatini", phonecode: "+268" },
  { id: 205, iso: "SE", name: "Sweden", phonecode: "+46" },
  { id: 206, iso: "CH", name: "Switzerland", phonecode: "+41" },
  { id: 207, iso: "SY", name: "Syria", phonecode: "+963" },
  { id: 208, iso: "TW", name: "Taiwan", phonecode: "+886" },
  { id: 209, iso: "TJ", name: "Tajikistan", phonecode: "+992" },
  { id: 210, iso: "TZ", name: "Tanzania", phonecode: "+255" },
  { id: 211, iso: "TH", name: "Thailand", phonecode: "+66" },
  { id: 212, iso: "TL", name: "Timor-Leste", phonecode: "+670" },
  { id: 213, iso: "TG", name: "Togo", phonecode: "+228" },
  { id: 214, iso: "TK", name: "Tokelau", phonecode: "+690" },
  { id: 215, iso: "TO", name: "Tonga", phonecode: "+676" },
  { id: 216, iso: "TT", name: "Trinidad and Tobago", phonecode: "+1868" },
  { id: 217, iso: "TN", name: "Tunisia", phonecode: "+216" },
  { id: 218, iso: "TR", name: "Turkey", phonecode: "+90" },
  { id: 219, iso: "TM", name: "Turkmenistan", phonecode: "+993" },
  { id: 220, iso: "TC", name: "Turks and Caicos Islands", phonecode: "+1649" },
  { id: 221, iso: "TV", name: "Tuvalu", phonecode: "+688" },
  { id: 222, iso: "UG", name: "Uganda", phonecode: "+256" },
  { id: 223, iso: "UA", name: "Ukraine", phonecode: "+380" },
  { id: 224, iso: "AE", name: "United Arab Emirates", phonecode: "+971" },
  { id: 225, iso: "GB", name: "United Kingdom", phonecode: "+44" },
  { id: 226, iso: "US", name: "United States", phonecode: "+1" },
  {
    id: 227,
    iso: "UM",
    name: "United States Minor Outlying Islands",
    phonecode: "+1",
  },
  { id: 228, iso: "UY", name: "Uruguay", phonecode: "+598" },
  { id: 229, iso: "UZ", name: "Uzbekistan", phonecode: "+998" },
  { id: 230, iso: "VU", name: "Vanuatu", phonecode: "+678" },
  { id: 231, iso: "VE", name: "Venezuela", phonecode: "+58" },
  { id: 232, iso: "VN", name: "Vietnam", phonecode: "+84" },
  { id: 233, iso: "VG", name: "British Virgin Islands", phonecode: "+1284" },
  {
    id: 234,
    iso: "VI",
    name: "United States Virgin Islands",
    phonecode: "+1340",
  },
  { id: 235, iso: "WF", name: "Wallis and Futuna", phonecode: "+681" },
  { id: 236, iso: "EH", name: "Western Sahara", phonecode: "+212" },
  { id: 237, iso: "YE", name: "Yemen", phonecode: "+967" },
  { id: 238, iso: "ZM", name: "Zambia", phonecode: "+260" },
  { id: 239, iso: "ZW", name: "Zimbabwe", phonecode: "+263" },
];

export default phonecodes;
